<template lang="pug">
  div#visit
    v-card.imageTop(width="100%" height="400",dark)
      v-img(src="../assets/img/1566097129.jpg" height="100%"  )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            p.display-2.font-weight-black.visit-title Visit City of Refuge
    router-view 
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.visit-title
  font-family Cardo, 'san-serif' !important
  color var(--v-primary-base)
</style>
